// extracted by mini-css-extract-plugin
export default {"message":"styles_message__5K1CE","spin":"styles_spin__ije2j"};